$(document).ready(function () {

    var helper = require('./../helper');

    let engineProperty = new Bloodhound({
        datumTokenizer: function (datum) {
            return Bloodhound.tokenizers.whitespace(datum.name);
        },
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            url: helper.getOrigin() + "/api/properties/all/search/%QUERY",
            wildcard: '%QUERY'
        },
        filter: function (response) {
            return $.map(response.properties, function (object) {
                return {
                    id: object.id,
                    name: object.name,
                    property_id: object.property_id
                };
            });
        }
    });

    let engineTicketId = new Bloodhound({
        datumTokenizer: function (datum) {
            return Bloodhound.tokenizers.whitespace(datum.name);
        },
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            url: helper.getOrigin() + "/api/tickets/search/%QUERY",
            wildcard: '%QUERY'
        },
        filter: function (response) {
            return $.map(response.properties, function (object) {
                return {
                    id: object.id,
                };
            });
        }
    });

    function generateTicketIdEngine(propertyId) {
        return engineTicketId = new Bloodhound({
            datumTokenizer: function (datum) {
                return Bloodhound.tokenizers.whitespace(datum.name);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: helper.getOrigin() + "/api/tickets/search/",
                replace: function ( url, query ) {
                    url += encodeURIComponent(query);
                    if (propertyId) {
                        return url = url + '/' + encodeURIComponent(propertyId);
                    } else {
                        return url;
                    }
                }
            },
            filter: function (response) {
                return $.map(response.properties, function (object) {
                    return {
                        id: object.id,
                    };
                });
            }
        });
    }

    $(document).on('change', '[name="property_name"], [name$="[property_name]"]', function () {
        let propertyId = $(this).closest('.property-by-ticket').find('.js-property-id-field').val();
        let ticketIdField = $(this).closest('.property-by-ticket').find('.js-ticket-id-field-typeahead-initialized');

        ticketIdField.typeahead('destroy').removeClass('js-ticket-id-field-typeahead-initialized');
        typeaheadInitTicketId(generateTicketIdEngine(propertyId));
    });


    $('.js-property-field-typeahead').on('typeahead:select', function (ev, suggestions) {

        var $this = $(this),
            $field =  $this.parent().parent().find('.js-property-id-field');

        $field.val(suggestions.id);
    });

    function typeaheadInitProperty(engine = engineTicketId) {
        $('.js-property-field-typeahead:not(.js-property-field-typeahead-initialized)')
            .addClass('js-property-field-typeahead-initialized')
            .typeahead(null, {
                minLength: 1,
                display: 'name',
                valueKey: 'id',
                name: 'suggestions',
                displayKey: 'name',
                limit: 15,
                templates: {
                    empty: ['<div class="empty-message" style="padding: 10px;"><strong>', 'Unable to find properties', '</strong></div>'].join('\n'),
                    suggestion: function (data) {
                        return '<p style="font-size: 100%; cursor: pointer;"><strong>' + data.name + '(' + data.property_id + ')' + '</strong></p>';
                    }
                },
                source: engine
            });

        $('.js-property-field-typeahead').on('typeahead:select', function (ev, suggestions) {

            var $this = $(this),
                $field =  $this.parent().parent().find('.js-property-id-field');

            $field.val(suggestions.id);
        });
    }

    function typeaheadInitTicketId(engine = engineProperty) {
        $('.js-ticket-id-field-typeahead:not(.js-ticket-id-field-typeahead-initialized)')
            .addClass('js-ticket-id-field-typeahead-initialized')
            .typeahead(null, {
                minLength: 3,
                display: 'id',
                valueKey: 'id',
                name: 'suggestions',
                displayKey: 'id',
                limit: 15,
                templates: {
                    empty: ['<div class="empty-message" style="padding: 10px;"><strong>', 'No such Ticket', '</strong></div>'].join('\n'),
                    suggestion: function (data) {
                        return '<p style="font-size: 100%; cursor: pointer;"><strong>' + data.id + '</strong></p>';
                    }
                },
                source: engine
            }).on('change typeahead:select', function (ev) {
                let ticketId = $(this).val();
                let propertyID = $(this).closest('.property-by-ticket').find('.js-property-id-field');
                let propertyName = $(this).closest('.property-by-ticket').find('.js-property-field-typeahead');

                $.ajax({
                    url         : helper.getOrigin() + "/api/property-by-ticket/" + ticketId,
                    method      : "get",
                    contentType : 'application/json',
                    dataType    : 'json',

                }).done(function (response) {
                        propertyID.val(response.propertyId);
                        propertyName.typeahead('val', response.propertyName);
                        propertyName.trigger('change');
                });
            });
    }

    module.exports.engineTicketsId = engineTicketId;
    module.exports.engineProperty = engineProperty;
    module.exports.typeaheadInitProperty = typeaheadInitProperty;
    module.exports.typeaheadInitTicketId = typeaheadInitTicketId;
});